import { getUserId } from 'app/auth/selectors';
import { downloadUrl } from 'app/common/utils/download';
import { getRoutineSaga } from 'app/common/utils/new-sagas';
import { showMessage } from 'app/messages/actions';
import { showErrorMessageSaga } from 'app/messages/saga';
import type { SagaIterator } from 'redux-saga';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import type { ActionType } from 'typesafe-actions';
import {
  type ProjectExportCompleted,
  projectExportCompleted,
  projectExportRoutine,
  resetProjectExport
} from './actions';
import { exportProject, getProjectExport } from './api';

export function* triggerExport(): SagaIterator {
  yield call(exportProject);
}

export function* handleExportDownload(action: ActionType<ProjectExportCompleted>): SagaIterator {
  const { exportId, userId } = action.payload;
  const currentUserId = yield select(getUserId);
  if (userId === currentUserId) {
    try {
      const data = yield call(getProjectExport, { exportId });
      yield call(downloadUrl, data.export.file, `${data.export.id}.zip`);
      yield put(resetProjectExport());
    } catch (e) {
      yield put(showMessage('error', e.message));
    }
  }
}

export default function* root(): SagaIterator {
  yield all([
    takeLatest(projectExportRoutine.REQUESTED, getRoutineSaga(projectExportRoutine, triggerExport)),
    takeLatest(projectExportRoutine.rejected, showErrorMessageSaga),
    takeLatest(projectExportCompleted, handleExportDownload)
  ]);
}
